import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Image, PixelRatio, Text, TouchableWithoutFeedback, View } from 'react-native';
import CommonStyles from 'common/CommonStyles';
import StatTraceContainer from 'tmpl/StatCompts/StatTraceContainer';
import { wrapStyle } from 'utils/computedStyle';

const NoResultStyle = wrapStyle({
  container: {
    paddingTop: 40,
    paddingBottom: 40,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f4f4f4',
  },
  imgStyle: {
    width: 90,
    height: 90,
    borderRadius: 45,
    overflow: 'hidden',
  },
  tipTxt: {
    paddingTop: 13,
    color: '#666',
    fontSize: 12,
  },
  btnOuter: {
    borderWidth: 1 / PixelRatio.get(),
    borderColor: '#666666',
    borderRadius: 16,
    paddingHorizontal: 14,
    paddingVertical: 8,
    marginTop: 14,
    backgroundColor: '#fff',
  },
  btnTxt: {
    color: '#666666',
    fontSize: 13,
  },
});

const parseTypeInfo = (type) => {
  const UnknownIcon = 'https://img.youpin.mi-img.com/shopcenter/92ae59b9_d233_4323_86b7_07c1c2696a7b.png';
  let txt = '';
  let imgSrc = '';
  let btnTxt = '';
  switch (type) {
    case 'unknown':
      txt = '未知异常，请稍后再试~';
      imgSrc = UnknownIcon;
      break;
    case 'serviceErr':
      txt = '服务器错误，请稍后再试~';
      imgSrc = UnknownIcon;
      break;
    case 'serviceLimit':
      txt = '人流拥挤，请稍后再试~';
      imgSrc = 'https://img.youpin.mi-img.com/shopcenter/045400eedb4b060ce62a87983719496e.png';
      break;
    case 'noNetwork':
      txt = '网络不稳定，请稍后再试~';
      imgSrc = 'https://img.youpin.mi-img.com/shopcenter/cf0b14f0dd5d990754b075f05b2d7997.png';
      break;
    case 'parseError':
      txt = '加载异常，请稍后再试~';
      imgSrc = 'https://img.youpin.mi-img.com/shopcenter/5a7ead25e236ded7cbe7aae68a537396.png';
      break;
    case 'unlogin':
      txt = '请登录后查看~';
      btnTxt = '去登录';
      imgSrc = 'https://img.youpin.mi-img.com/shopcenter/34b1a53866e8455f65e4604436bccb9b.png';
      break;
    case 'default':
    default:
      imgSrc = UnknownIcon;
      txt = '数据加载异常，请稍后再试~';
      break;
  }
  return {
    imgSrc: { uri: imgSrc },
    txt,
    btnTxt,
  };
};

class NoResult extends PureComponent {
  static propTypes = {
    btnClickFun: PropTypes.func.isRequired,
    isShowFullScreen: PropTypes.bool,
    customStyle: PropTypes.object,
    type: PropTypes.string,
  };

  static defaultProps = {
    customStyle: {},
    isShowFullScreen: false,
  };

  render() {
    let {
      traceId, // 埋点id
      isShowFullScreen,
      imgSrc, // 图片地址
      tipTxt, // 图片下方的提示文案
      btnTxt, // 按钮文案
      btnClickFun, // 按钮点击事件
      customStyle, // 自定义样式 class名和NoResultStyle统一即可
    } = this.props || {};

    let fullScreenStyle = null;
    if (this.props.type) {
      const parseData = parseTypeInfo(this.props.type);
      imgSrc = imgSrc || parseData.imgSrc;
      tipTxt = tipTxt || parseData.txt;
      btnTxt = btnTxt || parseData.btnTxt;
      fullScreenStyle = {
        flex: 1,
        paddingBottom: CommonStyles.ViewHeight * 0.25,
      };
      btnTxt = btnTxt || (btnClickFun ? '刷新' : '');
    }

    return (
      <View
        style={[
          NoResultStyle.container,
          isShowFullScreen ? { flex: 1, paddingBottom: CommonStyles.ViewHeight * 0.25 } : fullScreenStyle,
          customStyle.container,
        ]}
      >
        <Image
          style={[NoResultStyle.imgStyle, customStyle.imgStyle]}
          source={imgSrc || { uri: 'https://img.youpin.mi-img.com/shopcenter/144194d04c46a84e0cd81374528940ad.png' }}
        />
        <Text style={[NoResultStyle.tipTxt, customStyle.tipTxt]}>{tipTxt || ''}</Text>
        {btnTxt ? (
          traceId ? (
            <StatTraceContainer
              type={['visible', 'touch']}
              traceId={traceId}
              onPress={() => btnClickFun && btnClickFun()}
            >
              <View style={[NoResultStyle.btnOuter, customStyle.btnOuter]}>
                <Text style={[NoResultStyle.btnTxt, customStyle.btnTxt]}>{btnTxt}</Text>
              </View>
            </StatTraceContainer>
          ) : (
            <TouchableWithoutFeedback onPress={() => btnClickFun && btnClickFun()}>
              <View style={[NoResultStyle.btnOuter, customStyle.btnOuter]}>
                <Text style={[NoResultStyle.btnTxt, customStyle.btnTxt]}>{btnTxt}</Text>
              </View>
            </TouchableWithoutFeedback>
          )
        ) : null}
      </View>
    );
  }
}

export default NoResult;
